import React from 'react';
import Datetime from 'react-datetime';
import Input from 'blocks/Input';
import enhanceWithClickOutside from 'react-click-outside';
import moment from 'moment';
@enhanceWithClickOutside
export default class DateTimeWrapper extends React.Component {

  state = {value: this.props.value || null, opened: false, error: ''};


  handleOpen = () => {
    this.setState({opened: true})
  };

  componentWillReceiveProps = newProps => {
    this.setState({value: newProps.value,error: newProps.error})
  };

  handleClickOutside() {
    this.setState({opened: false})
  }



  render(){
    return (
      <div onClick={this.handleOpen}>
      <Datetime open={this.state.opened}
                renderInput={() => <Input name="expiry_date"
                                          type="text"
                                          readonly={true}
                                          error={this.state.error}
                                          value={this.state.value ? moment(this.state.value).format('D, MMM YYYY, h:mm a') : ''}
                                          placeholder="Expiration date"
      />
      }
                onChange={(startDate) => {
                  // this.setState({value: startDate})
                  this.props.handleChange({[this.props.name]: startDate})
                }
                }
      />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/blocks/DateTimeWrapper.jsx